import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BaseService } from '../../services/base.service';
import { CommonService } from '../../services/common.service';
import { FileAttachment } from '../../models/file-attachment.model';
import { NotificationsService } from '../../services/notification.service';

@Component({
  selector: 'ara-record-actions',
  templateUrl: './record-actions.component.html',
  styleUrls: ['./record-actions.component.css']
})
export class RecordActionsComponent implements OnInit {
  record: ModifyRecord;
  loggedInUserJSON: any;
  cancellationReason: string = '';
  showCancellationmsg: boolean = false;
  deletionReason: string = '';

  RestoreReason: string = '';
  showRestoremsg: boolean = false;
  showRestorePopup: boolean = false;

  AcceptReason: string = '';
  showAcceptmsg: boolean = false;
  showAcceptPopup: boolean = false;

  
  RejectReason: string = '';
  showRejectmsg: boolean = false;
  showRejectPopup: boolean = false;


  showDeletionmsg: boolean = false;
  showCancelPopup: boolean = false;
  showDeletePopup: boolean = false;
  Files: FileAttachment[] = [];
  @Input()
  ShowCancel: boolean = false;
  @Input()
  ShowDelete: boolean = false;
  @Input()
  ShowRestore: boolean = false;

  @Input()
  ShowAccept: boolean = false;
  @Input()
  ShowReject: boolean = false;


  @Input()
  ShowRestate: boolean = false;
  @Input()
  ModuleName: string;
  @Input()
  ApprovalLevel: number;

  @Input()
  SourceId: number;
  @Output()
  output: EventEmitter<boolean>;
  @Input()
  Status: string = '';
  @Input()
  ShowLabel: boolean = true;
  accept: string;
  Type: string = '';
  showRestatePopup: boolean = false;
  restateReason: any;
  showRestatemsg: boolean;

  constructor(private baseService: BaseService, private commonService: CommonService, private notificationsService: NotificationsService) {
    const loggedInUser = this.baseService.getItemFromSession('loggedInUser');
    this.loggedInUserJSON = JSON.parse(loggedInUser);
    this.accept = '.jpg,.JPG,.jpeg,.JPEG,.png,.PNG,.bmp,.BMP,.pdf,.PDF,.docx,.DOCX,.xlsx,.XLSX,.doc,.DOC,.pptx,.PPTX,.ppt,.PPT,.heic,.HEIC,.heif,.HEIF,.xls,.XLS';
    this.output = new EventEmitter<boolean>();
  }

  ngOnInit() {
    
    this.record = new ModifyRecord();
    this.record.SourceId = this.SourceId;
    this.record.ModuleName = this.ModuleName;
  }
  getRecordDetails() {
    
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: this.record
    }
    this.commonService.getRecordDetails(apiRequest, this.callbackMethodForGetRecordDetails.bind(this));
  }
  callbackMethodForGetRecordDetails(response) {
    if (response.Success) {
      response.Result.forEach(element => {
        if (element.Type === 'Cancel') {
          this.cancellationReason = element.Remarks;
          this.record.CancelFiles = element.Files;
        }
        if (element.Type === 'Delete') {
          this.deletionReason = element.Remarks;
          this.record.DeleteFiles = element.Files;
        }
        if (element.Type === 'Restate') {
          this.restateReason = element.Remarks;
          this.record.RestateFiles = element.Files;
        }
        if (element.Type === 'Restore') {
          this.RestoreReason = element.Remarks;
          this.record.RestateFiles = [];
        }
        if (element.Type === 'Accept') {
          this.AcceptReason = element.Remarks;
          this.record.RestateFiles = [];
        }
        if (element.Type === 'Reject') {
          this.RejectReason = element.Remarks;
          this.record.RestateFiles = [];
        }

      });
    }
    this.baseService.showRootLoader = false;
  }
  modifyRecord(Type) {
    this.Type = Type;
    this.getRecordDetails();
    switch (Type) {
      case 'Cancel':
        this.showCancelPopup = true;
        break;
      case 'Delete':
        this.showDeletePopup = true;
        break;
      case 'Restate':
        this.showRestatePopup = true;
        break;
        case 'Restore':
        this.showRestorePopup = true;
        
        break;
        case 'Accept':
        this.showAcceptPopup = true;
        break;
        case 'Reject':
        this.showRejectPopup = true;       
        break;
      default:
        break;
    }
  }

  checkPopUpValidation(Type, SourceId) {
    
    if (Type === 'Cancel' && !this.cancellationReason) {
      this.showCancellationmsg = true;
      return;
    }
    if (Type === 'Delete' && !this.deletionReason) {
      this.showDeletionmsg = true;
      return;
    }
    if (Type === 'Restate' && !this.restateReason) {
      this.showRestatemsg = true;
      return;
    }
    if (Type === 'Restore' && !this.RestoreReason) {
      this.showRestoremsg = true;
      return;
    }
    if (Type === 'Accept' && !this.AcceptReason) {
      this.showAcceptmsg = true;
      return;
    }
    if (Type === 'Reject' && !this.RejectReason) {
      this.showRejectmsg = true;
      return;
    }
    this.baseService.showRootLoader = true;
    this.record.SourceId = SourceId;
    this.record.Type = Type;
     
    this.record.UserId = this.loggedInUserJSON.UserId;
    this.record.ModuleName = this.ModuleName;
    this.record.IpAddress =this.baseService.getItemFromSession('ipAddress') ; 
     
    switch (Type) {
      case 'Cancel':
        this.record.Remarks = this.cancellationReason;
        this.record.Files = this.record.CancelFiles;
        break;
      case 'Delete':
        this.record.Remarks = this.deletionReason;
        this.record.Files = this.record.DeleteFiles;
        break;
      case 'Restate':
        this.record.Remarks = this.restateReason;
        this.record.Files = this.record.RestateFiles;
        break;
        case 'Restore':
        this.record.Remarks = this.RestoreReason;
        this.record.Files = [];
        break;
        case 'Accept':
        this.record.Remarks = this.AcceptReason;
        this.record.ApprovalLevel=this.ApprovalLevel;
        this.record.Files = [];
        break;
        case 'Reject':
        this.record.Remarks = this.RejectReason;
        this.record.ApprovalLevel=this.ApprovalLevel;
        this.record.Files = [];
        break;
      default:
        break;
    }
    const apiRequest = {
      Model: this.record
    }
    if (Type=='Restore')
    {
      this.commonService.restoreRecord(apiRequest, this.callbackMethodForModifyRecord.bind(this));
    }
    else if (Type=='Accept' || Type=='Reject')
    {
       this.commonService.AcceptOrReject(apiRequest, this.callbackMethodForModifyRecord.bind(this));
    }
    else 
    {
        this.commonService.modifyRecord(apiRequest, this.callbackMethodForModifyRecord.bind(this));
    }
  
}

  callbackMethodForModifyRecord(response) {
   
    if (response.Success) {
      switch (this.Type) {
        case 'Cancel':
          this.notificationsService.toastNotify('success', 'Success Message', 'Record is Cancelled Successfully');
          this.showCancelPopup = false;
          break;
        case 'Delete':
          this.notificationsService.toastNotify('success', 'Success Message', 'Record is Deleted Successfully');
          this.showDeletePopup = false;
          break;
        case 'Restate':
          this.notificationsService.toastNotify('success', 'Success Message', 'Record is Restated Successfully');
          this.showRestatePopup = false;
          break;
        case 'Restore':
          this.notificationsService.toastNotify('success', 'Success Message', 'Record is Restored Successfully');
          this.showRestorePopup = false;
          break;
        case 'Accept':
            this.notificationsService.toastNotify('success', 'Success Message', 'Record Approved');
            this.showAcceptPopup = false;
            break;
        case 'Reject':
            this.notificationsService.toastNotify('success', 'Success Message', 'Record Rejected');
            this.showRejectPopup = false;
            break;
        default:
          break;
      }
      this.output.emit(true);
      this.baseService.showRootLoader = false;
    } 
    else 
    {
      switch (this.Type) 
      {
        case 'Accept':
          this.notificationsService.toastNotify('error', 'Error Message', response.Result);
          break;
        case 'Reject':
          this.notificationsService.toastNotify('error', 'Error Message', response.Result);
            break;
        default:
          this.notificationsService.toastNotify('error', 'Error Message', 'Something went wrong!');
            break;
      }
      this.output.emit(false);
      this.baseService.showRootLoader = false;
    }
  }
  closeCancelPopup() {
    this.showCancelPopup = false;
  }
  closeDeletePopup() {
    this.showDeletePopup = false;
  }
  closeRestatePopup() {
    this.showRestatePopup = false;
  }
  closeRestorePopup() {
    this.showRestorePopup = false;
  }
  closeAcceptPopup() {
    this.showAcceptPopup = false;
  }
  closeRejectPopup() {
    this.showRejectPopup = false;
  }
  onInputFilesUpdated(Files, Type) {
    switch (Type) {
      case 'Cancel':
        this.record.CancelFiles = Files;
        break;
      case 'Delete':
        this.record.DeleteFiles = Files;
        break;
      case 'Restate':
        this.record.RestateFiles = Files;
        break;
        
    }
  }
  getRemarks(remarks, Type) {
    switch (Type) {
      case 'CancellationReason':
        this.cancellationReason = remarks;
        break;
      case 'DeletionReason':
        this.deletionReason = remarks;
        break;
      case 'RestateReason':
        this.restateReason = remarks;
        break;
        case 'RestoreReason':
          this.RestoreReason = remarks;
          break;
        case 'AcceptReason':
          this.AcceptReason = remarks;
          break;
        case 'RejectReason':
          this.RejectReason = remarks;
          break;
      default:
        break;
    }
  }
}
class ModifyRecord {
  Type: string;
  SourceId: number;
  UserId: number;
  ModuleName: string;
  ApprovalLevel:number;
  CancelFiles: FileAttachment[] = [];
  DeleteFiles: FileAttachment[] = [];
  RestateFiles: FileAttachment[] = [];
  
  Files: FileAttachment[] = [];
  Remarks: string;
  IpAddress:string;
}
